module.exports = __webpack_public_path__ + "05_glasses_black.d519b234.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer4/05_glasses_black.png
// module id = QiA5
// module chunks = 0